import React from "react";
import { css } from "@emotion/react"
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";

import { mediaQueries, pxToRem } from '@upsun/react-component-library/src/styles';

type AllServicesTableProps = {};

const AllServicesTable: React.FC<AllServicesTableProps> = ({ ...props }) => {
  const servicesTableStyles = css`
    ${mediaQueries.md} {
      td:first-of-type {
        width: 30%;
      }

      td:last-of-type {
        width: ${pxToRem(140)};
      }
    }
  `;

  return (
    <PricingTable {...props} css={servicesTableStyles}>
      <tbody>
        <tr>
          <BoldCell>
            Onboarding services<sup>†</sup>
          </BoldCell>
          <td>A structured journey from contract to go-live, including guided environment setup, configuration, staging deployment, migration assistance, technical training, and hands-on support through production launch.</td>
          <td><a href="/contact-us/">Contact sales</a></td>
        </tr>
        <tr>
          <BoldCell>
            Expert services<sup>†</sup>
          </BoldCell>
          <td>Project-based engagements for architecture, complex integrations, large migrations, and other initiatives that go beyond standard setup. Delivered by senior technical success managers with defined outcomes, timelines, and responsibilities.</td>
          <td><a href="/contact-us/">Contact sales</a></td>
        </tr>
        <tr>
          <BoldCell>
            Application services<sup>†</sup>
          </BoldCell>
          <td>Ongoing, application-centric managed services such as pipeline configuration, preview environment management, observability and monitoring, release automation, and lifecycle assistance.</td>
          <td><a href="/contact-us/">Contact sales</a></td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default AllServicesTable;
